import styled from 'styled-components';
import { IconSubtask } from '@tabler/icons-react';

interface ContainerPropsType {
  $groupColor: string;
}

export const Container = styled.div<ContainerPropsType>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: 0 5px;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: ${(props) => props.$groupColor && '14px 0px 0px -13px rgba(255, 255, 255, 1) inset'};
  border-left: ${(props) => props.$groupColor && `5px solid ${props.$groupColor}`};
  border-radius: 4px 0 0 4px;
`;

export const ListEventContainer = styled.div<ContainerPropsType>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 5px;
  border-radius: 4px;
  border-left: ${(props) => props.$groupColor && `4px solid ${props.$groupColor}`};
  @media screen and (max-width: 700px) {
    flex-direction: column;
    justify-content: center;
    align-items: start;
  }
`;

export const ListEventContent = styled.div`
  min-width: 200px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
`;

export const LineHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const GroupName = styled.div`
  font-size: 11.5px;
  font-weight: 400;
  max-width: 90%;
  width: fit-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 3px;
  @media screen and (max-width: 700px) {
    text-overflow: clip;
    display: block !important;
    overflow: visible;
  }
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 13.5px;
  max-width: 98%;
  width: fit-content;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 15px;
  @media screen and (max-width: 700px) {
    font-size: 12px;
    padding-top: 5px;
    text-overflow: clip;
    display: block !important;
    overflow: visible;
  }
`;

export const IconSubitem = styled(IconSubtask)`
  min-width: 15px;
  max-width: 15px;
  height: 15px;
  margin-right: 2px;
  @media screen and (max-width: 700px) {
    min-width: 13px;
    max-width: 13px;
    height: 13px;
  }
`;

export const ItemName = styled.span`
  font-weight: 300;
  font-size: 12.5px;
  text-overflow: ellipsis;
`;

interface HeaderPropsType {
  $isShort: boolean;
  $isAllDay: boolean;
  $isAllDayEventData: boolean;
}

export const Header = styled.div<HeaderPropsType>`
  display: flex;
  flex-direction: ${(props) =>
    props.$isAllDay && props.$isAllDayEventData ? 'row' : props.$isShort ? 'row' : 'column'};
  ${Title} {
    margin-top: 2px;
    display: ${(props) => (props.$isAllDay && props.$isAllDayEventData ? 'block' : '-webkit-box')};
    max-width: ${(props) =>
      props.$isShort
        ? 'calc(100% - 100px)'
        : props.$isAllDay && props.$isAllDayEventData
          ? 'calc(100% - 20px)'
          : '98%'};
    -webkit-line-clamp: ${(props) => (props.$isShort ? '1' : '2')};
    margin-left: ${(props) => (props.$isShort ? '5px' : '0')};
    white-space: ${(props) => (props.$isShort ? 'nowrap' : 'initial')};
    display: ${(props) => (props.$isShort ? 'inline-block' : '-webkit-box')};
  }
  ${GroupName} {
    display: ${(props) => (props.$isShort ? 'none' : 'initial')};
  }
`;

export const ListEventHeader = styled.div`
  min-width: 350px;
  max-width: 350px;
  margin-right: 8px;
  @media screen and (max-width: 700px) {
    min-width: 150px;
    max-width: 150px;
    padding-bottom: 5px;
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 5px;
`;

export const Value = styled.div`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 500;
`;

export const ContentValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  background-color: #4b4b4b2a;
  padding: 2px 6px;
  border-radius: 4px;
  min-height: 24px;
`;

export const PeopleTextValue = styled.div`
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  font-weight: 500;
`;

interface StatusPropsType {
  $color: string;
  $isBackgroundColor: boolean;
}

export const StatusContainer = styled.div<StatusPropsType>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 60%;
  min-width: 60px;
  height: 24px;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${(props) => props.$color};
  border: ${(props) => props.$isBackgroundColor && '0.5px solid #fff'};
  color: #fff;
`;

export const Status = styled.div`
  font-weight: 600;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

interface EventIndicatorPropsType {
  $color: string;
  $isAllDay: boolean;
}

export const EventIndicator = styled.div<EventIndicatorPropsType>`
  display: ${(props) => (props.$isAllDay ? 'none' : 'block')};
  background-color: ${(props) => props.$color};
  min-width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  @media screen and (max-width: 700px) {
    height: 6px;
    min-width: 6px;
    margin-right: 3px;
  }
`;

export const YearEventIndicator = styled.div<EventIndicatorPropsType>`
  display: ${(props) => (props.$isAllDay ? 'none' : 'block')};
  background-color: ${(props) => props.$color};
  min-width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 3px;
  @media screen and (max-width: 700px) {
    height: 6px;
    min-width: 6px;
  }
`;

export const MonthTime = styled.div`
  margin: 0 5px;
  @media screen and (max-width: 700px) {
    display: none;
  }
`;

export const YearTime = styled.div`
  margin: 0 3px;
  @media screen and (max-width: 700px) {
    display: none;
  }
`;

export const Time = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  @media screen and (max-width: 700px) {
    display: none;
  }
`;

interface AllDayTitlePropsType {
  $isSubitem: boolean;
}

export const AllDayTitle = styled.div<AllDayTitlePropsType>`
  font-weight: 600;
  font-size: 13.5px;
  max-width: ${(props) => (props.$isSubitem ? 'calc(100% - 34px)' : 'calc(100% - 18px)')};
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  @media screen and (max-width: 700px) {
    font-size: 12px;
    text-overflow: clip;
    display: block !important;
    overflow: visible;
  }
`;

interface MonthTitlePropsType {
  $isSubitem: boolean;
}

export const MonthTitle = styled.div<MonthTitlePropsType>`
  font-weight: 600;
  max-width: ${(props) => (props.$isSubitem ? 'calc(100% - 94px)' : 'calc(100% - 80px)')};
  font-size: 13px;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  @media screen and (max-width: 700px) {
    font-size: 12px;
    text-overflow: clip;
    display: block !important;
    overflow: visible;
  }
`;

export const YearTitle = styled.div`
  font-weight: 600;
  max-width: calc(100% - 40px);
  font-size: 13px;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  @media screen and (max-width: 700px) {
    font-size: 12px;
    text-overflow: clip;
    display: block !important;
    overflow: visible;
  }
`;

export const Location = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const LocationText = styled.div`
  width: calc(100% - 15px);
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
`;

export const PeopleText = styled.div`
  margin: 5px 0;
`;

export const People = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 5px;
`;

export const ListEventPeople = styled.div`
  display: flex;
  align-items: center;
`;

export const Avatar = styled.img`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin: 0 -3px;
  z-index: 10;
  border: 1px solid rgb(248, 248, 248);
`;

export const ExtraAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin: 0 -3px;
  z-index: 10;
  background-color: #333;
  color: white;
`;

export const Footer = styled.div`
  position: relative;
  margin-top: auto;
  width: 100%;
`;

export const LinkSection = styled.div`
  max-width: 100%;
  width: fit-content;
`;

export const Link = styled.a`
  display: block;
  color: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: underline !important;
`;
